<template>
  <div
    class="room-alert-component"
    @keydown="keymap"
  >
    <div class="room-alert">
      <div class="room-alert-header"></div>
      <div class="room-alert-body">
        <div class="alert-text-container">
          <p class="alert-text title">{{ title }}</p>
          <p class="alert-text text" v-html="text" />
          <div v-if="type === 'input' || type === 'checkbox'"
               class="alert-input-container flex justify-center items-center"
          >
            <input v-if="type === 'input'"
                   v-model="inputValue"
                   ref="input"
                   class="alert-input"
                   type="text"
                   :id="`alert_${type}`"
                   @keyup.enter="onClickOk"
            />
            <GrmCheckbox v-else-if="type === 'checkbox'"
                         :id="`alert_${type}`"
                         v-model="inputValue"
            >{{ this.typeDescription }}</GrmCheckbox>
          </div>
        </div>
      </div>
      <div class="room-alert-footer">
        <ul class="button-list">
          <li class="button-item" v-if="!onlyOk"><VButton class="cancel" @click="onClickCancel">{{ cancelText }}</VButton></li>
          <li class="button-item"><VButton ref="ok" @click="onClickOk">{{ okText }}</VButton></li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
import VButton from "@/components/Common/VButton";
import GrmCheckbox from "@/components/Common/input/GrmCheckbox";

export default {
  name: 'GrmAlert',
  components: {
    VButton,
    GrmCheckbox,
  },
  props: {
    type: {
      type: String,
      default: 'text'
    },
    typeDescription: {
      type: String,
      default: '',
    },
    title: {
      type: String,
      default: function() {return this.$t('common.alert.title')}
    },
    text: {
      type: String,
      default: ''
    },
    cancelText: {
      type: String,
      default: function() {return this.$t('common.cancel')}
    },
    okText: {
      type: String,
      default: function() {return this.$t('common.confirm')}
    },
    ok: {
      type: Function,
      default: () => {}
    },
    cancel: {
      type: Function,
      default: () => {}
    },
    onlyOk: {
      type: Boolean,
      default: false
    },
    finally: {
      type: Function,
      default: () => {}
    },
  },
  data(){
    return{
      inputValue: this.initInputValue(),
    }
  },
  mounted() {
    setTimeout(() => {
      this.$refs.ok.$refs.button.focus();
      if(this.type === 'input'){
        this.$refs.input.focus();
      }
    }, 100)
  },
  methods: {
    keymap(e) {
      switch (e.keyCode) {
        case 27: // esc
          this.onClickCancel();
          break
      }
    },
    onClickCancel() {
      try{
        this.cancel();
      }finally{
        this.destroy();
        this.finally();
      }
    },
    onClickOk() {
      try{
        if(this.inputValue !== ''){
          this.ok(this.inputValue);
        } else {
          this.ok();
        }
        if (this.$parent.callback) {
          this.$parent.callback()
        }
      }finally{
        this.destroy();
        this.finally();
      }
    },
    initInputValue() {
      switch (this.type) {
        case 'checkbox': return false;
        default: return '';
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.room-alert-component {
  background-color: rgba(0, 0, 0, 0.4);
  display: flex;
  justify-content: center;
  align-items: center;
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 9999;
}
.room-alert {
  min-width: 320px;
  border-radius: 10px;
  padding: 36px 30px 30px;
  background-color: #fff;
  box-sizing: border-box;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.4);
  text-align: center;
}
.alert-text-container {
  display: flex;
  flex-direction: column;
  gap: 20px 0;
}
.alert-text {
  &.title {
    font-size: 24px;
    font-weight: 700;
  }
  &.text {
    font-size: 14px;
    color: #666;
    line-height: 20px;
  }
}
.room-alert-footer {
  margin-top: 30px;
}
.button-list {
  display: flex;
  justify-content: center;
  gap: 0 10px;
}
.button {
  min-width: 100px;
  border-radius: 6px;
  padding: 0 24px;
  font-size: 15px;
  line-height: 40px;
  transition: 0.1s ease-out;
  &.cancel {
    background-color: #f1f2f3;
    color: #666;
    &:hover {
      background-color: #ddd;
    }
  }
  &.ok {
    background-color: $mainColor;
    color: #fff;
    &:hover {
      background-color: $subColor;
    }
  }
}
.alert-input-container {
  gap: 6px;
}
.alert-input{
  width: 100%;
  padding: 8px 14px;
  border: 1px solid #c8c8c8;
  border-radius: 10px;
  background-color: #f4f4f4;
  font-size: 14px;
  font-weight: bold;
  color: #333;

  &:focus {
    background-color: white;
    border-color: #59f;
    box-shadow: 0 6px 18px rgb(0 0 0 / 20%);
  }
}
.alert-label {
  font-size: 14px;
  color: #666;
  cursor: pointer;
}
</style>